import request from '../../utils/request';
import {paramSecret} from "../../utils/commonSecret";


// OAuth2-获取用户详情
export async function AuthUserInfo(params) {
    return request('/api/v1/business-server/member/userWealthInfo', {
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}

// 账号密码登录
export async function LoginForPcByPwd(params) {
    return request('/api/v1/business-server/member/loginForPcByPwd', {
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}

// QQ登录
export async function LoginForPcByQq(params) {
    return request('/api/v1/business-server/member/loginForPcByQq', {
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}

// 微博登录
export async function LoginForPcByWb(params) {
    return request('/api/v1/business-server/member/loginForPcByWb', {
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}

// 获取扫码登录code
export async function getLoginCode(params) {
    return request('/api/v1/user/get-login-code', {
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}


// 获取扫码登录code状态
export async function getLoginCodeState(params) {
    return request('/api/v1/user/get-login-code-state', {
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}

// 退出登录
export async function LogoutForPc(params) {
    return request('/api/v1/business-server/member/logoutForPc', {
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}

// 根据pms获取
export async function getTokenParam(params, urlPm) {
    return request('/api/v1/business-server/api/getTokenParam' + urlPm, {
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}

